import { Suspense } from 'react'
import { Spin } from 'antd'

export default function LazyPage({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<Spin style={{ display: 'block', margin: '120px auto' }} />}>
      {children}
    </Suspense>
  )
}
